import { render, staticRenderFns } from "./M_mailConfigure.vue?vue&type=template&id=65563826&scoped=true&"
import script from "./M_mailConfigure.vue?vue&type=script&lang=js&"
export * from "./M_mailConfigure.vue?vue&type=script&lang=js&"
import style0 from "./M_mailConfigure.vue?vue&type=style&index=0&id=65563826&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65563826",
  null
  
)

export default component.exports